<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">     
      
      <el-dialog title="商品信息变更日志" :visible.sync="showview" width="95%" top="2vh" :before-close="closewindows">
          
          <div class="cz-mall-goods-edit-main">
                <div class="cz-mall-goods-edit-log-notice">温馨提示：修改后的项里背景色标红处为修改后与修改前内容不同的项</div>

                <!-- 记录时间轴列表 -->
                <div class="cz-mall-goods-edit-log-lists cz-mall-goods-edit-log-left" v-loading="editgoodsloading">
                    <div :class="item.isselect==0 ? 'cz-mall-goods-edit-log-infos' : 'cz-mall-goods-edit-log-infos cz-mall-goods-edit-log-isselect' " v-for="(item,index) in editloglists" :key="index" @click="readlogs(item)">
                        <div class="cz-mall-goods-edit-log-infos-left">
                            <div class="cz-mall-goods-edit-log-infos-left-imgs"><img :src="item.isselect==0 ? require('../../../assets/edithistory.png') : require('../../../assets/edithistory_select.png')" /></div>
                            <div class="cz-mall-goods-edit-log-infos-left-line"><span></span></div>
                        </div>
                        <div class="cz-mall-goods-edit-log-infos-right">
                            <div class="cz-mall-goods-edit-log-content">{{item.description}}<a><img :src="item.isselect==0 ? require('../../../assets/look.png') : require('../../../assets/look_green.png')" /></a></div>
                            <div class="cz-mall-goods-edit-log-time">{{item.inputtime}}</div>
                            <div class="cz-mall-goods-edit-log-time">{{item.username}}</div>
                            <div class="cz-mall-goods-edit-log-time">端口：{{item.port}}</div>
                            <div class="cz-mall-goods-edit-log-time">ID：{{item.id}}</div>
                        </div>
                    </div>
                </div>

                <!-- 记录信息详情 -->
                <div class="cz-mall-goods-edit-log-lists cz-mall-goods-edit-log-right" v-loading="loginfosloading">

                    <div class="cz-mall-goods-edit-log-no" v-if="loginfos.length==0">
                        <img src="../../../assets/no_log.png" />
                        <span>当前无记录，请选择修改时间点</span>
                    </div>

                    <table border="0" class="cz-mall-goods-edit-log-contrast" v-if="loginfos.length > 0">
                        <tr>
                            <td class="cz-mall-goods-edit-log-bck" width="16%" align="center">对比项</td>
                            <td class="cz-mall-goods-edit-log-bck" width="42%" align="center">修改前</td>
                            <td class="cz-mall-goods-edit-log-bck" width="42%" align="center">修改后</td>
                        </tr>

                        <tr v-for="(item,index) in loginfos" :key="index">
                            <td class="cz-mall-goods-edit-log-bck" width="16%" align="center">{{item.title}}</td>

                            <td class="cz-mall-goods-edit-log-ct" width="42%" align="left" v-if="item.type==1">
                                <div class="cz-mall-goods-edit-log-default-content">{{item.oldname}}{{item.oldid > 0 ? '（ID：'+item.oldid+'）' : '' }}</div>
                            </td>
                            <td :class="item.isdeferent==0 && item.type==1 && desctype==2 ? 'cz-mall-goods-edit-log-ct' : 'cz-mall-goods-edit-log-ct edit-log-diferent'" width="40%" align="left" v-if="item.type==1">
                                <div v-if="desctype==2" class="cz-mall-goods-edit-log-default-content">{{item.newname}}{{item.newid > 0 ? '（ID：'+item.newid+'）' : '' }}</div>
                                <span v-if="desctype==1" style="float:left;width:100%;text-align:center">/</span>
                            </td>

                            <td class="cz-mall-goods-edit-log-ct" width="42%" align="center"  v-if="item.type==2">
                                <div class="cz-mall-goods-edit-logs-speclists" v-for="(tt,ii) in item.oldname" :key="ii">
                                    <div class="cz-mall-goods-edit-logs-speclists-img">
                                        <img :src="tt.img!='' ? tt.img : require('../../../assets/default_img_mini.png')">
                                    </div>
                                    <div class="cz-mall-goods-edit-logs-font">
                                        <span class="cz-mall-goods-edit-logs-speclists-title">{{tt.property_name}}</span>
                                        <span class="cz-mall-goods-edit-logs-speclists-property">ID：{{tt.id}}，sku：{{tt.sku}}，重量：{{tt.weight}}</span>
                                        <span class="cz-mall-goods-edit-logs-speclists-property">单位ID：{{tt.unitid}}，单位：{{tt.unit}}，价格：{{tt.property_price}}</span>
                                        <span class="cz-mall-goods-edit-logs-speclists-property">
                                            代发商品：{{tt.isreplace==0 ? '否' : '是'}}，
                                            代发上下架：{{tt.isreplace_grouding==0 ? '上架' : '下架'}}，
                                            代发价格：￥{{tt.replace_price}}
                                        </span>
                                        <span class="cz-mall-goods-edit-logs-speclists-property">
                                            代发运费模板ID：{{tt.replace_shipping_tempid}}，
                                            代发运费模板：{{tt.replace_shipping_tempname}}
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td :class="item.isdeferent==0 && item.type==2 && desctype==2 ? 'cz-mall-goods-edit-log-ct' : 'cz-mall-goods-edit-log-ct edit-log-diferent'" width="42%" align="center" v-if="item.type==2">
                                <div v-if="desctype==2" class="cz-mall-goods-edit-logs-speclists" v-for="(tt,ii) in item.newname" :key="ii">
                                    <div class="cz-mall-goods-edit-logs-speclists-img">
                                        <img :src="tt.img!='' ? tt.img : require('../../../assets/default_img_mini.png')">
                                    </div>
                                    <div class="cz-mall-goods-edit-logs-font">
                                        <span class="cz-mall-goods-edit-logs-speclists-title">{{tt.property_name}}</span>
                                        <span class="cz-mall-goods-edit-logs-speclists-property">ID：{{tt.id}}，sku：{{tt.sku}}，重量：{{tt.weight}}</span>
                                        <span class="cz-mall-goods-edit-logs-speclists-property">单位id：{{tt.unitid}}，单位：{{tt.unit}}，价格：{{tt.property_price}}</span>
                                        <span class="cz-mall-goods-edit-logs-speclists-property">
                                            代发商品：{{tt.isreplace==0 ? '否' : '是'}}，
                                            代发上下架：{{tt.isreplace_grouding==0 ? '上架' : '下架'}}，
                                            代发价格：￥{{tt.replace_price}}
                                        </span>
                                        <span class="cz-mall-goods-edit-logs-speclists-property">
                                            代发运费模板ID：{{tt.replace_shipping_tempid}}，
                                            代发运费模板：{{tt.replace_shipping_tempname}}
                                        </span>
                                    </div>
                                </div>
                                <span v-if="desctype==1" style="float:left;width:100%;text-align:center">/</span>
                            </td>

                            <td class="cz-mall-goods-edit-log-ct" width="42%" align="center" v-if="item.type==3">
                                <div class="cz-mall-goods-edit-log-default-content">
                                    <div class="cz-mall-goods-edit-log-imglists">
                                        <div class="cz-mall-goods-edit-log-out">
                                            <div class="cz-mall-goods-edit-log-imglists-infos">
                                                <div class="cz-mall-goods-edit-log-imglists-infos-imgs">
                                                    <img :src="item.oldname!='' ? item.oldname : require('../../../assets/default_img_mini.png')">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td :class="item.isdeferent==0 && item.type==3 && desctype==2 ? 'cz-mall-goods-edit-log-ct' : 'cz-mall-goods-edit-log-ct edit-log-diferent'" width="42%" align="center" v-if="item.type==3">
                                <div v-if="desctype==2" class="cz-mall-goods-edit-log-default-content">
                                    <div class="cz-mall-goods-edit-log-imglists">
                                        <div class="cz-mall-goods-edit-log-out">
                                            <div class="cz-mall-goods-edit-log-imglists-infos">
                                                <div class="cz-mall-goods-edit-log-imglists-infos-imgs">
                                                    <img :src="item.newname!='' ? item.newname : require('../../../assets/default_img_mini.png')">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span v-if="desctype==1" style="float:left;width:100%;text-align:center">/</span>
                            </td>


                            <td class="cz-mall-goods-edit-log-ct" width="42%" align="center" v-if="item.type==4">
                                <div class="cz-mall-goods-edit-log-default-content">
                                    <div class="cz-mall-goods-edit-log-imglists">
                                        <div class="cz-mall-goods-edit-log-out">
                                            <div class="cz-mall-goods-edit-log-imglists-infos" v-for="(tt,ii) in item.oldname" :key="ii">
                                                <div class="cz-mall-goods-edit-log-imglists-infos-imgs">
                                                    <img :src="tt!='' ? tt : require('../../../assets/default_img_mini.png')">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td :class="item.isdeferent==0 && item.type==4 && desctype==2 ? 'cz-mall-goods-edit-log-ct' : 'cz-mall-goods-edit-log-ct edit-log-diferent'" width="42%" align="center" v-if="item.type==4">
                                <div v-if="desctype==2" class="cz-mall-goods-edit-log-default-content">
                                    <div class="cz-mall-goods-edit-log-imglists">
                                        <div class="cz-mall-goods-edit-log-out">
                                            <div class="cz-mall-goods-edit-log-imglists-infos" v-for="(tt,ii) in item.newname" :key="ii">
                                                <div class="cz-mall-goods-edit-log-imglists-infos-imgs">
                                                    <img :src="tt!='' ? tt : require('../../../assets/default_img_mini.png')">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span v-if="desctype==1" style="float:left;width:100%;text-align:center">/</span>
                            </td>

                        </tr>
                        

                        
                    </table>


                </div>

          </div>

      </el-dialog>
        
  </div>
  </transition> 
</template>

<script>
export default {
  props: ["value","view"],
  data () {
    return {
      url:this.GLOBAL.domain+"Goods/index",
      transitionshow:true,
      showview:false,
      editgoodsloading:false,
      editloglists:[],
      loginfos:[],
      loginfosloading:false,
      desctype:'',
    }  
  },

  watch: {

    view(val) {
       if(val) {
           this.showview=true;
           this.editgoodsloading=false;
           this.editloglists=[];
           this.getloglists();
       }
    },

  },

  mounted(){
     
  },

  methods:{

      /** 关闭模板窗口 **/
      closewindows() {
          this.showview=false; 
          this.view=false;
          this.$emit("finish",'');
      },


      /** 获取记录信息列表 **/
      getloglists() {
          this.editgoodsloading=true;
          this.editloglists=[];

          var resource = this.$resource(this.url);
		  resource.save({act:'getGoodsupdatelog',token:this.$cookies.get('token'),id:this.value}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.editgoodsloading=false;
			}else{   
                this.editloglists = JSON.parse(Base64.decode(res.data.Data));   
                var id='';
                var _this=this;
                this.editloglists.forEach(function(item,index) {
                    if(item.isselect==1) {
                        id=item.id;
                        _this.desctype=item.type;
                    }
                });

                this.getloginfos(id);
				this.editgoodsloading=false;        
			}
		  }).catch((res) => {
			  this.editgoodsloading=false;
		  });
      },

    
      /** 查看变更记录 **/
      readlogs(item) {
          this.editloglists.forEach(function(item,index) {
              item.isselect=0;
          });

          var id=item.id;
          this.desctype=item.type;
          item.isselect=1;
          this.getloginfos(id);
      },


      /** 获取记录信息详情 **/
      getloginfos(id) {
          this.loginfosloading=true;
          this.loginfos=[];

          var resource = this.$resource(this.url);
		  resource.save({act:'getGoodsloginfos',token:this.$cookies.get('token'),id:id}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.loginfosloading=false;
			}else{   
                this.loginfos = JSON.parse(Base64.decode(res.data.Data));   
                console.log(this.loginfos);
				this.loginfosloading=false;        
			}
		  }).catch((res) => {
			  this.loginfosloading=false;
		  });
      },


  }

}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 1% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}

.cz-mall-goods-edit-log-notice {display:inline-block;width:calc(100% - 20px);padding:5px 10px;background:rgba(221,221,221,.3);border:1px solid rgba(221,221,221,.7);border-radius:6px;color:#f56c6c;font-size:12px;line-height:18px;margin-bottom:10px;}
.cz-mall-goods-edit-log-lists {display:inline-block;width:100%;font-size:0;}
.cz-mall-goods-edit-log-infos {float:left;width:100%;height:150px;cursor:pointer}
.cz-mall-goods-edit-log-infos-left {float:left;width:30px;height:150px;}
.cz-mall-goods-edit-log-infos-left-imgs {float:left;width:30px;height:30px;display:flex;justify-content:center;align-items:center;}
.cz-mall-goods-edit-log-infos-left-imgs img {width:20px;height:20px;}
.cz-mall-goods-edit-log-infos-left-line {float:left;width:30px;height:120px;display:flex;justify-content:center;align-items:center;}
.cz-mall-goods-edit-log-infos-left-line span {float:left;width:1px;height:120px;border-left:2px solid #e4e7ed;}
.cz-mall-goods-edit-log-isselect  .cz-mall-goods-edit-log-infos-left-line span {border-left:2px solid #67C23A;}
.cz-mall-goods-edit-log-isselect  .cz-mall-goods-edit-log-content {color:#67C23A}
.cz-mall-goods-edit-log-isselect  .cz-mall-goods-edit-log-time {color:#67C23A}


.cz-mall-goods-edit-log-infos-right {float:left;width:calc(100% - 30px - 20px);height:calc(120px - 20px);padding:10px;}
.cz-mall-goods-edit-log-content {float:left;width:100%;height:30px;overflow:hidden;font-size:13px;line-height:21px;color:#333336;display:flex;align-items:center;font-weight:400}
.cz-mall-goods-edit-log-content a {cursor:pointer;display:flex;align-items:center;margin-left:5%;}
.cz-mall-goods-edit-log-content img {width:20px;height:20px;}
.cz-mall-goods-edit-log-time {float:left;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:12px;line-height:23px;color:#909399;font-weight:400}

.cz-mall-goods-edit-main {display:inline-block;width:100%;height:530px;transition:.5s all;}
.cz-mall-goods-edit-log-left {float:left;width:20%;height:500px;overflow-x:hidden;overflow-y:auto;}
.cz-mall-goods-edit-log-right {float:left;width:calc(80% - 40px);height:calc(500px - 40px);padding:20px;overflow-x:hidden;overflow-y:auto;background:rgba(221,221,221,.4);position:relative;}
.cz-mall-goods-edit-log-no {display:flex;justify-content:center;align-items:center;position:absolute;width:100%;height:100%;top:0;left:0;}
.cz-mall-goods-edit-log-no img {width:35px;height:35px;}
.cz-mall-goods-edit-log-no span {font-size:13px;line-height:21px;margin-left:1%;font-weight:300;}

.cz-mall-goods-edit-log-contrast {width:100%;border-collapse:collapse;border:1px solid #DCDFE6;}
.cz-mall-goods-edit-log-contrast td {font-size:13px;line-height:21px;color:#333336;padding:25px;font-weight:400;border:1px solid #DCDFE6;}
.cz-mall-goods-edit-log-bck {background:#E4E7ED;}
.cz-mall-goods-edit-log-ct {background:#F2F6FC;}

.cz-mall-goods-edit-logs-speclists {float:left;width:calc(100% - 10px);padding:7px 5px;border-bottom:1px solid #C0C4CC;display:flex;align-items:center;}
.cz-mall-goods-edit-logs-speclists-img {float:left;width:50px;height:50px;background:rgba(144,147,153,.3);border:1px dashed rgba(144,147,153,.3);border-radius:6px;display:flex;justify-content:center;align-items:center;}
.cz-mall-goods-edit-logs-speclists-img img {border-radius:6px;max-width:90%;max-height:90%;}

.cz-mall-goods-edit-logs-font {float:left;width:calc(100% - 50px - 2px - 5%);margin-left:5%;}
.cz-mall-goods-edit-logs-speclists-title {float:left;width:100%;margin-left:2%;font-size:12px;line-height:21px;text-align:left;color:#333336;}
.cz-mall-goods-edit-logs-speclists-property {float:left;width:100%;margin-left:2%;font-size:12px;line-height:21px;text-align:left;color:#999999;font-weight:400;border-bottom:1px dashed #C0C4CC;padding:5px 0;}
.cz-mall-goods-edit-logs-speclists-money {float:left;width:100%;margin-left:2%;font-size:12px;line-height:21px;text-align:left;color:#909399;font-weight:400;}
.cz-mall-goods-edit-log-imglists {float:left;width:100%;display:flex;justify-content:center;min-height:50px;}
.cz-mall-goods-edit-log-out {float:left;width:100%;}
.cz-mall-goods-edit-log-imglists-infos {float:left;width:50px;height:50px;padding:10px;}
.cz-mall-goods-edit-log-imglists-infos-imgs {width:50px;height:50px;background:rgba(144,147,153,.3);border:1px dashed rgba(144,147,153,.3);border-radius:6px;display:flex;justify-content:center;align-items:center;}
.cz-mall-goods-edit-log-imglists-infos-imgs img {max-width:90%;max-height:90%;border-radius:6px;}

.edit-log-diferent {background:#fde2e2;}
.edit-log-diferent .cz-mall-goods-edit-log-default-content {color:#f56c6c;}
.edit-log-diferent .cz-mall-goods-edit-logs-speclists {border-color:#f56c6c;}
.edit-log-diferent .cz-mall-goods-edit-logs-speclists-img {background:#fff;border-color:#fff;}
.edit-log-diferent .cz-mall-goods-edit-logs-speclists-title,.edit-log-diferent .cz-mall-goods-edit-logs-speclists-property,
.edit-log-diferent .cz-mall-goods-edit-logs-speclists-money {color:#f56c6c;}
.edit-log-diferent .cz-mall-goods-edit-log-imglists-infos-imgs {background:#fff;border-color:#fff;}
</style>


// WEBPACK FOOTER //
// src/components/mall/shipping/goodseditlog.vue